import faker from 'faker';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { formatDistance } from 'date-fns';
import { Link as RouterLink } from 'react-router-dom';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
// material
import {
  Box,
  Stack,
  Link,
  Card,
  Button,
  Divider,
  Typography,
  CardHeader,
  CardActions,
  CardActionArea,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// utils
import { mockImgCover } from '../../../utils/mockImages';
import useWidth from '../../../hooks/useWidth';
//

// ----------------------------------------------------------------------

const NEWS = [...Array(5)].map((_, index) => {
  const setIndex = index + 1;
  return {
    title: faker.name.title(),
    description: faker.lorem.paragraphs(),
    image: mockImgCover(setIndex),
    postedAt: faker.date.soon()
  };
});

// ----------------------------------------------------------------------

NewsItem.propTypes = {
  news: PropTypes.object.isRequired
};

function NewsItem({ news }) {
  const { image, title, description, postedAt } = news;

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box
        component="img"
        alt={title}
        src={image}
        sx={{ width: 48, height: 48, borderRadius: 0.5 }}
      />
      <Box sx={{ minWidth: 240 }}>
        <Link to="#" color="inherit" underline="hover" component={RouterLink}>
          <Typography variant="subtitle2" noWrap>
            {title}
          </Typography>
        </Link>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {description}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ pr: 3, flexShrink: 0, color: 'text.secondary' }}>
        {formatDistance(postedAt, new Date())}
      </Typography>
    </Stack>
  );
}

export default function RequestsServiceItem({ item, handleClick }) {
  const width = useWidth(useTheme, useMediaQuery);
  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      spacing={1}
      sx={
        ['xs'].includes(width)
          ? { maxWidth: 250, minHeight: 350, boxShadow: 4, borderRadius: 4 }
          : {
              maxWidth: 250,
              minHeight: 280,
              boxShadow: 4,
              borderRadius: 4
            }
      }
    >
      <Stack direction="column" spacing={1} p={2}>
        <Typography variant="h6">{item.name}</Typography>
        <Typography pr={1}>{item.summary}</Typography>
      </Stack>

      <Box
        sx={{
          p: 2,
          textAlign: 'right',
          bgcolor: item.status === 'inactive' ? 'background.neutral' : 'primary.main',
          borderBottomLeftRadius: 30,
          borderBottomRightRadius: 30,
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          overflow: 'hidden'
        }}
      >
        <Button
          disabled={item.status === 'inactive'}
          size="small"
          color="inherit"
          endIcon={<Icon icon={arrowIosForwardFill} />}
          sx={{ color: 'white' }}
          onClick={() => handleClick(item)}
        >
          Pilih {item.status === 'inactive' && '( Tidak aktif )'}
        </Button>
      </Box>
    </Stack>
  );
}
